"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfCreateVerifiedNurseLicensesDto = instanceOfCreateVerifiedNurseLicensesDto;
exports.CreateVerifiedNurseLicensesDtoFromJSON = CreateVerifiedNurseLicensesDtoFromJSON;
exports.CreateVerifiedNurseLicensesDtoFromJSONTyped = CreateVerifiedNurseLicensesDtoFromJSONTyped;
exports.CreateVerifiedNurseLicensesDtoToJSON = CreateVerifiedNurseLicensesDtoToJSON;
exports.CreateVerifiedNurseLicensesDtoToJSONTyped = CreateVerifiedNurseLicensesDtoToJSONTyped;
const CreateVerifiedNurseLicenseDto_1 = require("./CreateVerifiedNurseLicenseDto");
/**
 * Check if a given object implements the CreateVerifiedNurseLicensesDto interface.
 */
function instanceOfCreateVerifiedNurseLicensesDto(value) {
    if (!('licenses' in value) || value['licenses'] === undefined)
        return false;
    return true;
}
function CreateVerifiedNurseLicensesDtoFromJSON(json) {
    return CreateVerifiedNurseLicensesDtoFromJSONTyped(json, false);
}
function CreateVerifiedNurseLicensesDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'licenses': (json['licenses'].map(CreateVerifiedNurseLicenseDto_1.CreateVerifiedNurseLicenseDtoFromJSON)),
    };
}
function CreateVerifiedNurseLicensesDtoToJSON(json) {
    return CreateVerifiedNurseLicensesDtoToJSONTyped(json, false);
}
function CreateVerifiedNurseLicensesDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'licenses': (value['licenses'].map(CreateVerifiedNurseLicenseDto_1.CreateVerifiedNurseLicenseDtoToJSON)),
    };
}
//# sourceMappingURL=CreateVerifiedNurseLicensesDto.js.map